export default class Update {

    id = '';
    description = '';
    version = '';
    channel = '';
    os = '';
    active = false;
    filename = '';
    type = '';

    constructor() {
    }
}